import React, { FunctionComponent, ReactNode } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

const HeaderSegment = styled(Segment)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const LabelsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

type ReviewHeaderProps = {
  title?: string;
  bold?: boolean;
  labels?: ReactNode;
  meta?: ReactNode;
};

export const ReviewHeader: FunctionComponent<ReviewHeaderProps> = ({
  title,
  bold = true,
  labels,
  meta,
}) => (
  <HeaderSegment>
    <Header
      as="h4"
      style={{ marginBottom: '2px', fontWeight: bold ? 700 : 'normal' }}
    >
      {title || 'Avis'}
    </Header>
    {labels ? <LabelsRow>{labels}</LabelsRow> : null}
    {meta}
  </HeaderSegment>
);
